<template>
  <layout-main-inner title="服务产品">
    <el-dropdown slot="action">
      <el-button type="primary">
        新增服务产品<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in list"
          :key="item.serviceId"
          @click.native="additem(item)">{{ item.serviceName }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <layout-card-wrap>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          v-for="item in list"
          :key="item.serviceId"
          :label="item.serviceName"
          :name="item.serviceId + ''">
          <service-table
            :ref="'tab_' +item.serviceId"
            :service="item" />
        </el-tab-pane>
      </el-tabs>
    </layout-card-wrap>
    <edit-service-modal
      ref="service"
      :callback="cb"
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import ServiceTable from './service-table.vue'
import EditServiceModal from './editServiceModal'
export default {
  name: 'CategorysIndex',
  components: { ServiceTable, EditServiceModal },
  data() {
    return {
      loading: true,
      activeName: '-1',
      list: [],
      config: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    additem(row) {
      this.$refs.service.add(row)
    },
    cb(serviceId) {
      this.$refs['tab_' + serviceId][0].getlist()
    },
    handleClick(tab, event) {
      console.log('tab_' + tab.name, event)
      const ref = 'tab_' + tab.name
      this.$refs[ref][0].getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getservices', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          // this.totalNum = res.data.total
          this.list = res.data.records
          this.activeName = this.list[0] ? this.list[0].serviceId + '' : '-1'
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
